import { ref, computed, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { accounts, accountMap } from '@/config/loan';
let id = 0;
export default {
  props: {
    token: {
      type: String,
      default: ''
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    pledgeAccount: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  emits: ['change'],
  setup(props, {
    emit
  }) {
    const store = useStore();
    const {
      t
    } = useI18n({
      useScope: 'global'
    });
    const selectRef = ref(`accountSelect${id += 1}`);
    const visible = ref(false);
    // 是否为统一账户
    const isUTA = computed(() => store.getters['user/isUTA']);
    const isLogin = computed(() => store.getters['user/isLogin']);
    const filterData = ref([]);
    const selectedValue = ref('');
    const popperOptions = {
      modifiers: [{
        name: 'flip',
        options: {
          // 默认为bottom-start，如果底部空间不够，则设置为top-start
          fallbackPlacements: ['top-start']
        }
      }]
    };
    watch(() => isLogin.value, login => {
      let account = null;
      const defaultData = [accounts.fund];
      if (!login) {
        filterData.value = defaultData;
        [account] = defaultData;
      } else if (isUTA.value) {
        filterData.value = [accounts.uta, accounts.fund];
        account = accountMap[props?.pledgeAccount] || accounts.uta;
      } else {
        filterData.value = defaultData;
        [account] = defaultData;
      }
      selectedValue.value = account;
      emit('change', account?.type);
    }, {
      immediate: true
    });
    const methods = {
      handleSelect(item) {
        visible.value = false;
        selectedValue.value = item;
        emit('change', item.type);
      },
      handleBodyClick(e) {
        const cdom = document.querySelector(`#${selectRef.value}`);
        if (!cdom) {
          return;
        }
        if (cdom?.contains(e.target)) {
          visible.value = !visible.value;
        } else {
          visible.value = false;
        }
      }
    };
    document.querySelector('body')?.addEventListener('click', methods.handleBodyClick);
    onBeforeUnmount(() => {
      document.querySelector('body')?.removeEventListener('click', methods.handleBodyClick);
    });
    return {
      t,
      ...methods,
      filterData,
      popperOptions,
      visible,
      selectRef,
      selectedValue
    };
  }
};